// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signuppage_right_part .form-group {
    text-align: left;
    margin-bottom: 12px;
}

.signuppage_right_part strong {
    display: inline-block;
    text-align: center;
    font-family: 'Poppins-Regular';
    font-size: 18px;
    color: #354959;
    font-weight: 500;
    margin: 30px 0 0;
}

.signuppage_section {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.signuppage_right_part h2 {
    text-align: left;
    margin: 0 0 .7em;
    color: #354959;
    font-size: 50px;
}

.signuppage_right_part strong a {
    color: #3c7546;
    font-family: 'Poppins-Bold';
    font-size: 18px;
}

.termsprivacy_section p a {
    color: #00929f;
}

.termsprivacy_section p {
    font-size: 16px;
    letter-spacing: 0px;
    color: #354959;
    margin: 0;
}

.termsprivacy_section {
    margin: 3em 0 0;
    text-align: center;
}

.signuppage_section.login_page .signuppage_right_part h4 {
    text-align: left;
    font-size: 20px;
    color: #354959;
    font-family: 'Poppins-Regular';
}

.forgetpass_sec {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
}

.forgetpass_sec span {
    font-size: 15px;
    color: #354959;
    font-family: 'Poppins-Regular';
    font-weight: 600;
    position: relative;
    padding-left: 20px;
}

.resend-otp {
    font-family: 'Poppins-Regular';
    font-weight: 600;
}

.forgetpass_sec a {
    font-size: 15px;
    letter-spacing: 0px;
    color: #3c7546;
    font-weight: 600;
}

.round {
    position: relative;
}

.round label {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    height: 20px;
    left: 0;
    position: absolute;
    top: 3px;
    width: 20px;
    margin: 0;
}

.round label:after {
    border: 2px solid #fff;
    border-top: none;
    border-right: none;
    content: "";
    height: 6px;
    left: 4px;
    opacity: 0;
    position: absolute;
    top: 4px;
    transform: rotate(-45deg);
    width: 12px;
}

.round input[type="checkbox"] {
    visibility: hidden;
}

.round input[type="checkbox"]:checked+label {
    background-color: #008b89;
    border-color: #008b89;
}

.round input[type="checkbox"]:checked+label:after {
    opacity: 1;
}

.signuppage_right_part ul li {
    text-align: center;
    display: inline-block;
    float: left;
    width: 50%;
}

.signuppage_right_part ul {
    position: absolute;
    left: 0;
    top: -30px;
    width: 90%;
    right: 0;
    margin: 0 auto;
    border-radius: 34px;
    filter: drop-shadow(6px 10.392px 14.5px rgba(0, 0, 0, 0.15));
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
}

.signuppage_right_part ul li a {
    font-size: 20px;
    text-transform: uppercase;
    color: #354959;
    font-weight: 600;
    display: flex;
    height: 65px;
    align-items: center;
    justify-content: center;
    border-radius: 35px;
}

.signuppage_section.login_page .signuppage_right_part {
    padding: 5em 5em 3em;
}

.signuppage_right_part ul .active {
    border-radius: 35px;
    background-color: #00929f;
}

.signuppage_right_part ul .active a {
    color: #ffffff;
}

.telehealthform_sec p {
    text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,UAAU;IACV,UAAU;IACV,QAAQ;IACR,cAAc;IACd,mBAAmB;IACnB,4DAA4D;IAC5D,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".signuppage_right_part .form-group {\r\n    text-align: left;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.signuppage_right_part strong {\r\n    display: inline-block;\r\n    text-align: center;\r\n    font-family: 'Poppins-Regular';\r\n    font-size: 18px;\r\n    color: #354959;\r\n    font-weight: 500;\r\n    margin: 30px 0 0;\r\n}\r\n\r\n.signuppage_section {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-around;\r\n}\r\n\r\n.signuppage_right_part h2 {\r\n    text-align: left;\r\n    margin: 0 0 .7em;\r\n    color: #354959;\r\n    font-size: 50px;\r\n}\r\n\r\n.signuppage_right_part strong a {\r\n    color: #3c7546;\r\n    font-family: 'Poppins-Bold';\r\n    font-size: 18px;\r\n}\r\n\r\n.termsprivacy_section p a {\r\n    color: #00929f;\r\n}\r\n\r\n.termsprivacy_section p {\r\n    font-size: 16px;\r\n    letter-spacing: 0px;\r\n    color: #354959;\r\n    margin: 0;\r\n}\r\n\r\n.termsprivacy_section {\r\n    margin: 3em 0 0;\r\n    text-align: center;\r\n}\r\n\r\n.signuppage_section.login_page .signuppage_right_part h4 {\r\n    text-align: left;\r\n    font-size: 20px;\r\n    color: #354959;\r\n    font-family: 'Poppins-Regular';\r\n}\r\n\r\n.forgetpass_sec {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 20px 0;\r\n}\r\n\r\n.forgetpass_sec span {\r\n    font-size: 15px;\r\n    color: #354959;\r\n    font-family: 'Poppins-Regular';\r\n    font-weight: 600;\r\n    position: relative;\r\n    padding-left: 20px;\r\n}\r\n\r\n.resend-otp {\r\n    font-family: 'Poppins-Regular';\r\n    font-weight: 600;\r\n}\r\n\r\n.forgetpass_sec a {\r\n    font-size: 15px;\r\n    letter-spacing: 0px;\r\n    color: #3c7546;\r\n    font-weight: 600;\r\n}\r\n\r\n.round {\r\n    position: relative;\r\n}\r\n\r\n.round label {\r\n    background-color: #fff;\r\n    border: 1px solid #ccc;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    height: 20px;\r\n    left: 0;\r\n    position: absolute;\r\n    top: 3px;\r\n    width: 20px;\r\n    margin: 0;\r\n}\r\n\r\n.round label:after {\r\n    border: 2px solid #fff;\r\n    border-top: none;\r\n    border-right: none;\r\n    content: \"\";\r\n    height: 6px;\r\n    left: 4px;\r\n    opacity: 0;\r\n    position: absolute;\r\n    top: 4px;\r\n    transform: rotate(-45deg);\r\n    width: 12px;\r\n}\r\n\r\n.round input[type=\"checkbox\"] {\r\n    visibility: hidden;\r\n}\r\n\r\n.round input[type=\"checkbox\"]:checked+label {\r\n    background-color: #008b89;\r\n    border-color: #008b89;\r\n}\r\n\r\n.round input[type=\"checkbox\"]:checked+label:after {\r\n    opacity: 1;\r\n}\r\n\r\n.signuppage_right_part ul li {\r\n    text-align: center;\r\n    display: inline-block;\r\n    float: left;\r\n    width: 50%;\r\n}\r\n\r\n.signuppage_right_part ul {\r\n    position: absolute;\r\n    left: 0;\r\n    top: -30px;\r\n    width: 90%;\r\n    right: 0;\r\n    margin: 0 auto;\r\n    border-radius: 34px;\r\n    filter: drop-shadow(6px 10.392px 14.5px rgba(0, 0, 0, 0.15));\r\n    background-color: #ffffff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 4px 6px;\r\n}\r\n\r\n.signuppage_right_part ul li a {\r\n    font-size: 20px;\r\n    text-transform: uppercase;\r\n    color: #354959;\r\n    font-weight: 600;\r\n    display: flex;\r\n    height: 65px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 35px;\r\n}\r\n\r\n.signuppage_section.login_page .signuppage_right_part {\r\n    padding: 5em 5em 3em;\r\n}\r\n\r\n.signuppage_right_part ul .active {\r\n    border-radius: 35px;\r\n    background-color: #00929f;\r\n}\r\n\r\n.signuppage_right_part ul .active a {\r\n    color: #ffffff;\r\n}\r\n\r\n.telehealthform_sec p {\r\n    text-align: left;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
